import React from 'react';

const NotLoaded = (/* props */) => <span />;

export default NotLoaded;



// WEBPACK FOOTER //
// ./src/components/views/NotLoaded.jsx